import { Component, inject, input, model, output, signal, ChangeDetectionStrategy } from '@angular/core';
import { IClienteData } from '@core/interfaces/entidades/cliente.entidad';
import { UiButton, UiDialog } from '@shared/components/ui';
import { CrearCliente } from '@shared/components/crear-cliente/crear-cliente';
import { ClienteApiService } from '@core/services/api/cliente-api.service';

@Component({
  selector: 'app-buscador-cliente',
  imports: [UiButton, UiDialog, CrearCliente],
  templateUrl: './buscador-cliente.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './buscador-cliente.css',
})
export class BuscadorCliente {
  private clienteApiService = inject(ClienteApiService);
  mostar_creador = input<boolean>(true);

  clientes = signal<IClienteData[]>([]);
  searchText = signal<string>('');
  dropdownOpen = signal<boolean>(false);

  cliente = model<IClienteData | null>(null);
  clienteSelected = output<IClienteData | null>();

  modal_crear_cliente = false;

  onQueryChange(query: string) {
    this.searchText.set(query);
    const q = query?.trim();

    if (!q || q.length < 2) {
      this.clientes.set([]);
      this.dropdownOpen.set(false);
      return;
    }

    this.clienteApiService.buscarCoincidencia(q).subscribe({
      next: (res) => {
        this.clientes.set(res);
        this.dropdownOpen.set(true);
      },
      error: () => {
        this.clientes.set([]);
        this.dropdownOpen.set(false);
      },
    });
  }

  selectCliente(cliente: IClienteData) {
    this.cliente.set(cliente);
    this.clienteSelected.emit(cliente);
    this.closeDropdown();
  }

  clearCliente() {
    this.cliente.set(null);
    this.searchText.set('');
    this.clientes.set([]);
    this.dropdownOpen.set(false);
  }

  closeDropdown() {
    this.dropdownOpen.set(false);
  }

  onCreated(cliente: IClienteData) {
    this.modal_crear_cliente = false;
    this.cliente.set(cliente);
  }
}
